export default () => <div class='icon-loading-animation' />
